import React from 'react';
import { T } from '../../../utils/I18n/I18n';
import clsx from 'clsx';
import './FormInput.scss';

const FormInput = props => {
  const {
    register, // Funkcja register z react-hook-form
    errors = {},
    type,
    text,
    name,
    className,
    defaultValue,
    isAdditionalInfo,
    isCheckbox,
    onChange,
    value,
    onClick,
    children,
    required = true,
    minLength,
    noAutoComplete,
    validationRules, // Nowy props dla reguł walidacji
  } = props;

  // Jeśli register nie jest przekazane, pomiń rejestrację
  let inputProps = {};
  if (register) {
    // Jeśli przekazano validationRules, użyj ich
    if (validationRules) {
      inputProps = register(name, validationRules);
    } else {
      // W przeciwnym razie użyj podstawowych reguł
      inputProps = register(name, { required, minLength });
    }
  }

  return (
      <div className={clsx('input-field', className, isCheckbox && 'input-field__checkbox')}>
        {text && (
            <label htmlFor={name} className={clsx(!isAdditionalInfo && 'input-field__label')}>
              {text}
            </label>
        )}
        {!children && (
            <input
                type={type}
                name={name}
                id={name}
                defaultValue={defaultValue}
                value={value}
                {...inputProps} // Rozkładamy właściwości z register
                className="input-field__input"
                onChange={e => {
                  inputProps.onChange && inputProps.onChange(e); // Wywołujemy domyślny onChange z register
                  onChange && onChange(e); // Wywołujemy niestandardowy onChange z propsów
                }}
                autoComplete={noAutoComplete ? 'new-password' : undefined}
                onClick={onClick}
            />
        )}
        {children && (
            <select
                {...inputProps} // Rozkładamy właściwości z register
                name={name}
                id={name}
                defaultValue={defaultValue}
                onChange={e => {
                  inputProps.onChange && inputProps.onChange(e);
                  onChange && onChange(e);
                }}
            >
              {children}
            </select>
        )}
        {errors[name] && (
            <span className="input-field__error">
          {errors[name].type === 'required' && <T id="formInput.required" />}
              {errors[name].type === 'oib' && <T id="formInput.oib" />}
              {errors[name].type === 'validate' && errors[name].message}
              {errors[name].type === 'minLength' && errors[name].message}
        </span>
        )}
      </div>
  );
};

export default FormInput;